import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import {
  SALESPERSON_DIALOG_COMPONENT_TOKEN,
  SALESPERSON_DIALOG_CONFIG_TOKEN,
} from '@galaxy/meeting-analysis/static';
import {EMPTY_STATE_IMAGE_URL} from '@galaxy/meeting-analysis/static';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { firstValueFrom } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'meeting-analysis-recordings-upgrade',
  templateUrl: './recordings-upgrade.component.html',
  styleUrl: './recordings-upgrade.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GalaxyEmptyStateModule, MatButtonModule, MatIconModule, TranslateModule, MatDialogModule, RouterLink],
})
export class RecordingsUpgradeComponent {
  private readonly dialog = inject(MatDialog);
  private readonly salespersonDialogComponent = inject(SALESPERSON_DIALOG_COMPONENT_TOKEN, { optional: true });
  private readonly salesDialogConfig$ = inject(SALESPERSON_DIALOG_CONFIG_TOKEN, { optional: true });
  private readonly snackbarService = inject(SnackbarService);

  readonly emptyStateImageUrl = EMPTY_STATE_IMAGE_URL;
  readonly learnMoreUrl = 'https://docs.vendasta.com/ai/ai-workforce/ai-sales-assistant';

  readonly benefits = [
    'RECORDING_UPGRADE.BENEFIT_1',
    'RECORDING_UPGRADE.BENEFIT_2',
    'RECORDING_UPGRADE.BENEFIT_3',
  ] as const;

  async openSalespersonDialog(config?: MatDialogConfig): Promise<void> {
    if (!this.salespersonDialogComponent) {
      console.warn('SALESPERSON_DIALOG_COMPONENT_TOKEN not provided');
      this.snackbarService.openErrorSnack('COMMON.ERROR');
      return;
    }

    if (config) {
      this.dialog.open(this.salespersonDialogComponent, config);
      return;
    }

    if (!this.salesDialogConfig$) {
      console.warn('SALESPERSON_DIALOG_CONFIG_TOKEN not provided');
      this.snackbarService.openErrorSnack('COMMON.ERROR');
      return;
    }

    try {
      const dialogConfig = await firstValueFrom(
        this.salesDialogConfig$.pipe(filter((cfg) => !!cfg)),
      );
      this.dialog.open(this.salespersonDialogComponent, dialogConfig);
    } catch (error) {
      console.warn('Failed to get dialog config from Salesperson Dialog Config Token', error);
      this.snackbarService.openErrorSnack('COMMON.ERROR');
    }
  }
}

